import React from 'react';

const AmbitoCards = ({ ambitos, onSelect, onBack, t }) => (
  <div>
    <button
      onClick={onBack}
      className="flex items-center gap-2 text-sm text-white bg-[#34568B] hover:bg-[#2c4775] px-4 py-2 rounded-full shadow transition mb-6 mt-5"
    >
      ← {t('labels.back_to_profiles', 'Volver a perfiles')}
    </button>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      {ambitos.map(ambito => (
        <div
          key={ambito.id}
          className="cursor-pointer p-4 shadow rounded-xl border bg-white hover:bg-gray-100"
          onClick={() => onSelect(ambito)}
        >
          <h3 className="text-lg font-medium text-center">
            {t(`labels.${ambito.nombre}`, ambito.nombre)}
          </h3>
        </div>
      ))}
    </div>
  </div>
);

export default AmbitoCards;
